import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProductStart, setProduct } from './../../redux/Products/products.actions';
import { addProduct } from './../../redux/Cart/cart.actions';
import Button from './../forms/Button';
import './styles.scss';

const mapState = state => ({
  product: state.productsData.product
});

var nf = new Intl.NumberFormat();

const ProductCard = ({ }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { productID } = useParams();
  const { product } = useSelector(mapState);

  const {
    image,
    pname,
    price,
    description,
  } = product;

  useEffect(() => {
    dispatch(
      fetchProductStart(productID)
    )

    return () => {
      dispatch(
        setProduct({})
      )
    }

  }, []);

  const handleAddToCart = (product) => {
    if (!product) return;
    dispatch(
      addProduct(product)
    );
    history.push('/cart');
  }

  const configAddToCartBtn = {
    type: 'button'
  }

  return (


    <div className="productDetails">
      <div className="productCard">
        <div className="cardleft">
          <div className="hero">
            <img src={image} />
          </div>

        </div>
        <div className="productDetails">
          <ul>
            <li>
              <h1>
                {pname}
              </h1>
            </li>
            <li>
              <span>
                {'\u20A6'}{nf.format(price)}
              </span>
            </li>
            <li>
              <div className="addToCart">
                <Button className="btn" {...configAddToCartBtn} onClick={() => handleAddToCart(product)}>
                  Add to cart
              </Button>
              </div>
            </li>
            <li>
              <span
                className="desc"
                dangerouslySetInnerHTML={{ __html: description }} />
            </li>


          </ul>
        </div>
      </div>
      <div className="productCard2">
        <h1>
          Product Details
        </h1>
      </div>
    </div>
  );
}

export default ProductCard;
